/**
 * Validation for whether a company may move a contract forward — i.e. open
 * "Förhandsgranska" (preview) or "Signera och skicka" (sign). A main contract
 * needs a contract name (avtalsnamn) AND either free-text assignment
 * description OR the "refer to attached documents" flag. ÄTA/variation
 * amendments are settlements and are exempt. This mirrors the backend guard so
 * the same rule holds in both places.
 */
export interface ContractForwardInput {
  contractType?: string | null;
  contractName: string;
  /** HTML from the rich-text assignment description editor. */
  assignmentDescription: string;
  referToAttachments: boolean;
}

export interface ContractForwardValidation {
  ok: boolean;
  missingName: boolean;
  missingAssignment: boolean;
}

const plainTextLength = (html: string): number =>
  html.replace(/<[^>]*>/g, '').trim().length;

export function validateContractForForwarding(
  input: ContractForwardInput
): ContractForwardValidation {
  // Amendments (ÄTA / variation) carry no separate assignment description.
  if ((input.contractType ?? 'fixed') === 'variation') {
    return { ok: true, missingName: false, missingAssignment: false };
  }
  const missingName = plainTextLength(input.contractName) === 0;
  const missingAssignment =
    plainTextLength(input.assignmentDescription) === 0 && !input.referToAttachments;
  return { ok: !missingName && !missingAssignment, missingName, missingAssignment };
}
